import config from '../config'

function findDashboardSize() {
    var minHeight = 480;
	var minWidth  = 300;
    var width;
    var innerWidth = window.innerWidth;

	// The minus px here leaves us room for the header and menu. Adjust as needed.
	var height = window.innerHeight - 67;
    var workspaceContent = document.querySelector('.workspace__content');
    if (workspaceContent !== null) {
        var isToolbarOpen = workspaceContent.classList.contains('toolbar-is-open');
        if ( isToolbarOpen ) {
            height += 22;
        }
    }

    if (innerWidth > 1024){
        width = innerWidth - 240;
    } else {
        width = innerWidth;
    }

	if (height < minHeight) {
		height = minHeight;
	}

    if (width < minWidth) {
		width = minWidth;
	}

	return {
		'width'  : width,
		'height' : height
	}
}

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

function getShadowIframe(hostEl) {
    try {
        const shadow = hostEl && hostEl.shadowRoot;
        if (!shadow) return null;
        return shadow.querySelector('iframe');
    } catch {
        return null;
    }
}

function ensureIframe100(hostEl) {
    const ifr = getShadowIframe(hostEl);
    if (!ifr) return false;
    ifr.style.width = '100%';
    ifr.style.height = '100%';
    ifr.style.border = 'none';
    return true;
}

function resize() {
    var workspaceContent =  document.querySelector('.workspace__content-inside');
    var vizHost = document.querySelector( '#tableauViz' );
    if (workspaceContent !== null && vizHost !== null) {
        var size = findDashboardSize();

        workspaceContent.style.width = size.width + "px";
        workspaceContent.style.height = size.height + "px";
        vizHost.style.width = "100%";
        vizHost.style.height = "100%";
        vizHost.style.display = 'block';

        if (!ensureIframe100(vizHost)) {
            // if iframe does not exist yet, observe it, until it is there
            const mo = new MutationObserver(() => {
                if (ensureIframe100(vizHost)) {
                    mo.disconnect();
                }
            });
            mo.observe(vizHost, { childList: true, subtree: true });
        }
    }
}

window.addEventListener('resize', resize);

const Viz = (function () {

    var _instance;
    var _viz;
    var size = findDashboardSize();

    const createViz = async (dom, pth, contentUrl, trustedTicket, callback, events, hideToolbar ) => {
        return new Promise(function (resolve, reject) {
            if (dom && pth && trustedTicket) {
                const size = findDashboardSize();
                _viz && _viz.dispose && _viz.dispose();
                var path = `${config.APP_CONFIG.tableauHost}/trusted/${trustedTicket}${contentUrl === "" ? "" : "/t/" + contentUrl}/${pth}`

                _viz = document.createElement('tableau-viz');
                _viz.setAttribute('src', path);
                _viz.setAttribute('width', `${size.width}px`);
                _viz.setAttribute('height', `${size.height}px`);
                _viz.setAttribute('toolbar', hideToolbar ? 'hidden' : 'top');
                _viz.setAttribute('hide-tabs', 'true');
                _viz.id = 'tableauViz';

                // register events
                events.forEach(({ type, handler }) => {
                    _viz.addEventListener(type, handler);
                });

                dom.innerHTML = ''; // empties the container
                dom.appendChild(_viz); // adds the new element

                if(_viz) {
                    if (events != null && events.length)
                    {
                        for(var i=0;i<events.length;i++)
                        {
                            _viz.removeEventListener(events[i].type, events[i].handler);
                            _viz.addEventListener(events[i].type, events[i].handler);

                        }
                        _viz.addEventListener(window.tableau.TableauEventType.FirstInteractive, callback);
                    }
                    // if the window is maximized and toolbar is being toggled
                    resize();
                    resolve(_viz)
                } else {
                    reject("Viz could not be created")
                }
               
            } else {
                reject("Parameters missng to init viz")
            }

        })
    }

    const Viz = () => {
        if (!_instance) {    
            _instance = this;
        }
        return _instance;
    }

    Viz.prototype = {
        getViz: () => _viz,
        createViz: (domEl, path, contentUrl, trustedTicket, callback, events, hideToolbar) => createViz(domEl, path, contentUrl, trustedTicket, callback, events, hideToolbar),
        exportToPDF: () => _viz.displayDialogAsync(window.tableau.TableauDialogType.ExportPDF),
        exportData: async () => {
            // get the currently active sheet (dashboard in this case)
            const activeSheet = _viz.workbook.activeSheet;
            const worksheets = activeSheet.worksheets;
            if(worksheets.length > 0) {
                // use the first worksheet
                const selectedWorksheetForExport = worksheets[0];
                // include all columns in the summary data
                const columns = await selectedWorksheetForExport.getSummaryColumnsInfoAsync();
                const columnsToInclude = Array.from(columns, (column) => column.fieldId);
                const ignoreAliases = false;
                const exportDataOptions = {ignoreAliases, columnsToInclude};
                try {
                    await _viz.exportDataAsync(selectedWorksheetForExport.name, exportDataOptions);
                } catch {
                    console.error(e);
                }
            }
        },
        exportToImage: () => _viz.exportImageAsync(),
        exportAsCrosstab: () => _viz.displayDialogAsync(window.tableau.TableauDialogType.ExportCrossTab),
        revertAllAsync: () => _viz.revertAllAsync(),
        refreshDataAsync: () => _viz.refreshDataAsync(),    
        addEventListener: (eventType, listener) => _viz.addEventListener(eventType, listener),
        removeEventListener: (eventType, listener) => _viz.removeEventListener(eventType, listener)
    }

    return Viz;
}())

export default Viz;